import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '../shared/contexts/AuthContext';
import { ToastProvider } from '../shared/contexts/ToastContext';
// import { ModalStackProvider } from '../shared/contexts/ModalStackContext'; // ОТКЛЮЧЕНО: конфликтует с NavigationContext
import { NavigationProvider } from '../shared/contexts/NavigationContext';
import { BetaProvider } from '../shared/contexts/BetaContext';
// PWA отключен
// import PWAInstallPrompt from '../shared/ui/PWAInstallPrompt';
import PushNotificationPrompt from '../shared/ui/PushNotificationPrompt';
// Темы теперь импортируются в index.css
// ThemeProvider теперь в index.tsx (удалена дубликация)
import { AppRoutes } from './routes';

function App() {
  return (
    <AuthProvider>
      <BetaProvider>
      <ToastProvider>
        {/* <ModalStackProvider> ОТКЛЮЧЕНО: не используется и конфликтует с NavigationContext */}
          <Router>
            <NavigationProvider>
              <div className="App">
                <AppRoutes />
                {/* PWA отключен */}
                {/* <PWAInstallPrompt /> */}
                <PushNotificationPrompt />
              </div>
            </NavigationProvider>
          </Router>
        {/* </ModalStackProvider> */}
      </ToastProvider>
      </BetaProvider>
    </AuthProvider>
  );
}

export default App;
